module.exports = __webpack_public_path__ + "static/media/stefanSchmid.750c5957.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/stefanSchmid.jpg
// module id = 1698
// module chunks = 1